import React from 'react';
import { Spring, Trail, animated } from 'react-spring';
import {
  deesse,
  ge,
  headspace,
  omv,
  pra,
  sony,
  stanford,
  staples,
  w3w,
  zenefits
} from './images/index';
import styles from './style.css';

const items = [
  {
    name: 'Déesse',
    img: deesse,
    id: styles.deesse
  },
  {
    name: 'General Electric',
    img: ge,
    id: styles.ge
  },
  {
    name: 'Headspace',
    img: headspace,
    id: styles.hspace
  },
  {
    name: 'OMV',
    img: omv,
    id: styles.omv
  },
  {
    name: 'Pacific Reach Advisors',
    img: pra,
    id: styles.pra
  },
  {
    name: 'Sony Pictures',
    img: sony,
    id: styles.sony
  },
  {
    name: 'Stanford University',
    img: stanford,
    id: styles.sford
  },
  {
    name: 'Staples',
    img: staples,
    id: styles.staples
  },
  {
    name: 'what3words',
    img: w3w,
    id: styles.w3w
  },
  {
    name: 'Zenefits',
    img: zenefits,
    id: styles.zenefits
  }
];

const Clients = () => (
  <div className={styles.clients}>
    <Spring
      native
      from={{ opacity: 0, transform: 'translateX(-50%)' }}
      to={{ opacity: 1, transform: 'translateX(0%)' }}
    >
      {style => (
        <animated.div style={style} className={styles.clients__text__wrapper}>
          <div className={styles.clients__text}>
            <span>World class</span> brands <br />
            and startups
          </div>
        </animated.div>
      )}
    </Spring>

    <div className={styles.clients__logos__wrapper}>
      <div className={styles.clients__logos}>
        <Trail
          items={items}
          keys={item => item.name}
          native
          from={{ opacity: 0 }}
          to={{ opacity: 1 }}
          delay={500}
        >
          {({ name, img, id }) => style => (
            <animated.div
              className={styles.clients__logos__item}
              id={id}
              style={style}
            >
              <img alt={name} src={img} />
            </animated.div>
          )}
        </Trail>
      </div>
    </div>
  </div>
);

export default Clients;
